angular.module('ui.centre',
    [
        'ui.centre.list',
        'ui.centre.overview'
    ]);
